module.exports = __webpack_public_path__ + "img/horizontal_7_7_2.ac9c5aef.png";